import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import throttle from 'lodash/throttle';
import { childrenShape } from '@bibliocommons/bc-prop-types';
import Context from '@bibliocommons/context';

import './FullScreenOverlayContent.scss';

export default class FullScreenOverlayContent extends React.PureComponent {
  constructor(props) {
    super(props);
    this.contentRef = null;
    this.handleScroll = throttle(this.handleScroll, 50, {
      leading: true,
      trailing: true
    }).bind(this);
    this.state = {
      scrolled: false
    };
  }

  componentDidMount() {
    if (this.contentRef) {
      this.contentRef.addEventListener('scroll', this.handleScroll);
    }
  }

  componentWillUnmount() {
    if (this.contentRef) {
      this.contentRef.removeEventListener('scroll', this.handleScroll);
    }
  }

  handleScroll() {
    if (this.contentRef) {
      this.setState({
        scrolled: this.contentRef.scrollTop > 1
      });
    }
  }

  render() {
    const { className, children, size } = this.props;
    const classNames = cn('cp-full-screen-overlay-content', className, {
      'full-screen-overlay-content--mobile-app': this.context.mobileApp,
      'full-screen-overlay-content--scrolled': this.state.scrolled
    });

    const contentWrapper = cn('full-screen-overlay-content__wrapper', `full-screen-overlay-content__wrapper--${size}`);

    return (
      <main className={classNames} ref={el => (this.contentRef = el)}>
        <div className={contentWrapper}>{children}</div>
      </main>
    );
  }
}

FullScreenOverlayContent.defaultProps = {
  size: 'default'
};

FullScreenOverlayContent.propTypes = {
  className: PropTypes.string,
  children: childrenShape,
  size: PropTypes.oneOf(['default', 'small', 'medium'])
};

FullScreenOverlayContent.contextType = Context;
